import { render, staticRenderFns } from "./PopUpProductDescription.vue?vue&type=template&id=1d20aeeb&"
import script from "./PopUpProductDescription.vue?vue&type=script&lang=ts&"
export * from "./PopUpProductDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports